import ApiService from "@/core/services/api.service";
import Vue from "vue";

// action types
export const POPULATE_ACTIVITY_DISCUSSION_RESPONSES_LIST =
  "populateActivityDiscussionRepsonsesList";
export const POPULATE_ACTIVITY_DISCUSSION_RESPONSES_INFO =
  "populateActivityDiscussionRepsonsesInfo";
export const POPULATE_ACTIVITY_ADDITIONAL_DISCUSSION_RESPONSES_INFO =
  "populateActivityAdditionalDiscussionRepsonsesInfo";
export const CREATE_DISCUSSION_RESPONSES = "createDiscussionRepsonses";
export const UPDATE_DISCUSSION_RESPONSES = "updateDiscussionRepsonses";
export const DELETE_DISCUSSION_RESPONSES = "deleteDiscussionRepsonses";
export const CLEAR_DISCUSSION_RESPONSES_LIST = "clearDiscussionRepsonsesList";
export const CLEAR_DISCUSSION_RESPONSES_INFO = "clearDiscussionRepsonsesInfo";
export const CLEAR_DISCUSSION_RESPONSES_ERRORS =
  "clearDiscussionRepsonsesErrors";

// mutation types
export const SET_ACTIVITY_DISCUSSION_RESPONSES_LIST =
  "setActivityDiscussionRepsonsesList";
export const RESET_ACTIVITY_DISCUSSION_RESPONSES_LIST =
  "resetActivityDiscussionRepsonsesList";
export const SET_ACTIVITY_DISCUSSION_RESPONSES_INFO =
  "setActivityDiscussionRepsonsesInfo";
export const RESET_ACTIVITY_DISCUSSION_RESPONSES_INFO =
  "resetActivityDiscussionRepsonsesInfo";
export const APPEND_ACTIVITY_DISCUSSION_RESPONSES_LIST =
  "appendActivityDiscussionRepsonsesInfo";
export const ADD_ACTIVITY_DISCUSSION_RESPONSES =
  "addActivityDiscussionRepsonses";
export const UPDATE_ACTIVITY_DISCUSSION_RESPONSES =
  "updateActivityDiscussionRepsonses";
export const REMOVE_ACTIVITY_DISCUSSION_RESPONSES =
  "removeActivityDiscussionRepsonses";
export const SET_ACTIVITY_DISCUSSION_RESPONSES_ERRORS =
  "setActivityDiscussionRepsonsesErrors";
export const RESET_ACTIVITY_DISCUSSION_RESPONSES_ERRORS =
  "resetActivityDiscussionRepsonsesErrors";

const state = {
  activity_discussion_responses_errors: {},
  activity_discussion_responses_list: [],
  activity_discussion_responses_info: []
};

const getters = {
  activityDiscussionRepsonsesErrors(state) {
    return state.activity_discussion_responses_errors;
  },
  activityDiscussionRepsonsesList(state) {
    return state.activity_discussion_responses_list;
  },
  activityDiscussionRepsonsesInfo(state) {
    return state.activity_discussion_responses_info;
  }
};

const actions = {
  [POPULATE_ACTIVITY_DISCUSSION_RESPONSES_LIST](context, payload) {
    return ApiService.get(
      "api/v1/activities/" +
        payload.activityId +
        "/activity_discussion_responses",
      {
        params: payload.params
      }
    )
      .then(res => {
        const responses = res.data.data._embedded.activity_discussion_responses;
        context.commit(SET_ACTIVITY_DISCUSSION_RESPONSES_LIST, responses);
      })
      .catch(error => {
        if (error.response) {
          context.commit(
            SET_ACTIVITY_DISCUSSION_RESPONSES_ERRORS,
            error.response.data
          );
        } else {
          Vue.$log.error(error);
        }
        throw error;
      });
  },
  [POPULATE_ACTIVITY_DISCUSSION_RESPONSES_INFO](context, payload) {
    return ApiService.get(
      "api/v1/activities/" +
        payload.activityId +
        "/activity_discussion_responses" +
        payload.activityDiscussionResponseId,
      {
        params: payload.params
      }
    )
      .then(res => {
        const response = res.data.data;
        context.commit(SET_ACTIVITY_DISCUSSION_RESPONSES_INFO, response);
      })
      .catch(error => {
        if (error.response) {
          context.commit(
            SET_ACTIVITY_DISCUSSION_RESPONSES_ERRORS,
            error.response.data
          );
        } else {
          Vue.$log.error(error);
        }
        throw error;
      });
  },
  [POPULATE_ACTIVITY_ADDITIONAL_DISCUSSION_RESPONSES_INFO](context, payload) {
    return ApiService.get(
      "api/v1/activities/" +
        payload.activityId +
        "/activity_discussion_responses",
      {
        params: payload.params
      }
    )
      .then(res => {
        const responses = res.data.data._embedded.activity_discussion_responses;
        context.commit(
          APPEND_ACTIVITY_DISCUSSION_RESPONSES_LIST,
          payload,
          responses
        );
      })
      .catch(error => {
        if (error.response) {
          context.commit(
            SET_ACTIVITY_DISCUSSION_RESPONSES_ERRORS,
            error.response.data
          );
        } else {
          Vue.$log.error(error);
        }
        throw error;
      });
  },
  [CREATE_DISCUSSION_RESPONSES](context, payload) {
    return ApiService.post(
      "api/v1/activities/" +
        payload.activityId +
        "/activity_discussion_responses",
      payload.data
    )
      .then(res => {
        context.commit(ADD_ACTIVITY_DISCUSSION_RESPONSES, res.data.data);
        return res.data.data;
      })
      .catch(error => {
        if (error.response) {
          context.commit(
            SET_ACTIVITY_DISCUSSION_RESPONSES_ERRORS,
            error.response.data
          );
        } else {
          Vue.$log.error(error);
        }
        throw error;
      });
  },
  [UPDATE_DISCUSSION_RESPONSES](context, payload) {
    return ApiService.put(
      "api/v1/activities/" +
        payload.activityId +
        "/activity_discussion_responses/" +
        payload.responseId,
      payload.data
    )
      .then(res => {
        const response = res.data.data;
        context.commit(SET_ACTIVITY_DISCUSSION_RESPONSES_INFO, response);
      })
      .catch(error => {
        if (error.response) {
          context.commit(
            SET_ACTIVITY_DISCUSSION_RESPONSES_ERRORS,
            error.response.data
          );
        } else {
          Vue.$log.error(error);
        }
        throw error;
      });
  },
  [DELETE_DISCUSSION_RESPONSES](context, payload) {
    return ApiService.delete("api/v1/activities/" + payload.activity_id + "/activity_discussion_responses/" + payload.activity_response_id)
      .then(() => {
        context.commit(REMOVE_ACTIVITY_DISCUSSION_RESPONSES);
      })
      .catch((error) => {
        if (error.response) {
          context.commit(SET_ACTIVITY_DISCUSSION_RESPONSES_ERRORS, error.response.data);
        } else {
          Vue.$log.error(error);
        }
        throw error;
      });
  },
  [CLEAR_DISCUSSION_RESPONSES_LIST](context) {
    context.commit(RESET_ACTIVITY_DISCUSSION_RESPONSES_LIST);
  },
  [CLEAR_DISCUSSION_RESPONSES_INFO](context) {
    context.commit(RESET_ACTIVITY_DISCUSSION_RESPONSES_INFO);
  },
  [CLEAR_DISCUSSION_RESPONSES_ERRORS](context) {
    context.commit(RESET_ACTIVITY_DISCUSSION_RESPONSES_ERRORS);
  }
};

const mutations = {
  [SET_ACTIVITY_DISCUSSION_RESPONSES_LIST](
    state,
    activity_discussion_responses_list
  ) {
    state.activity_discussion_responses_list = activity_discussion_responses_list;
  },
  [RESET_ACTIVITY_DISCUSSION_RESPONSES_LIST](state) {
    state.activity_discussion_responses_list = [];
  },
  [SET_ACTIVITY_DISCUSSION_RESPONSES_INFO](
    state,
    activity_discussion_responses_info
  ) {
    state.activity_discussion_responses_info = activity_discussion_responses_info;
  },
  [RESET_ACTIVITY_DISCUSSION_RESPONSES_INFO](state) {
    state.activity_discussion_responses_info = [];
  },
  [ADD_ACTIVITY_DISCUSSION_RESPONSES](
    state,
    activity_discussion_responses_info
  ) {
    state.activity_discussion_responses_list.unshift(
      activity_discussion_responses_info
    );
  },
  [UPDATE_ACTIVITY_DISCUSSION_RESPONSES](
    state,
    activity_discussion_responses_info
  ) {
    let newActivityDiscussionRepsonsesArray = [];
    newActivityDiscussionRepsonsesArray.push(
      activity_discussion_responses_info
    );
    state.activity_discussion_responses_list = state.activity_discussion_responses_list.map(
      obj =>
        newActivityDiscussionRepsonsesArray.find(o => o.id === obj.id) || obj
    );
  },
  [APPEND_ACTIVITY_DISCUSSION_RESPONSES_LIST](
    state,
    payload,
    activity_discussion_responses_additional_list
  ) {
    let responseToIndex = state.activity_discussion_responses_list.findIndex(
      p => p.id == payload.responding_to
    ); // to be update
    if (responseToIndex !== -1) {
      state.activity_discussion_responses_list = state.activity_discussion_responses_list.splice(
        responseToIndex,
        0,
        activity_discussion_responses_additional_list
      );
    } else {
      state.activity_discussion_responses_list.push(
        activity_discussion_responses_additional_list
      );
    }
  },
  [REMOVE_ACTIVITY_DISCUSSION_RESPONSES](state, activityDiscussionResponseId) {
    state.activity_discussion_responses_list = state.activity_discussion_responses_list.filter(
      function(obj) {
        return obj.id !== activityDiscussionResponseId;
      }
    );
  },
  [SET_ACTIVITY_DISCUSSION_RESPONSES_ERRORS](
    state,
    activity_discussion_responses_errors
  ) {
    state.activity_discussion_responses_errors = activity_discussion_responses_errors;
  },
  [RESET_ACTIVITY_DISCUSSION_RESPONSES_ERRORS](state) {
    state.activity_discussion_responses_errors = [];
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
